import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const appStyles: Record<string, SystemStyleObject<Theme>> = {
  scrollbar: {
    '*': {
      msOverflowStyle: 'initial',
      scrollbarWidth: 'initial',
    },
    '*::-webkit-scrollbar': {
      display: 'block',
      width: 5,
      height: 8,
      backgroundColor: 'grey50',
      borderRadius: 5,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'grey150',
      borderRadius: 5,
    },
  },
  limitPageWidth: {
    maxWidth: theme => theme.dimensions.appLayout.maxWidth,
    mx: 'auto',
  },
  gradientText: {
    background: theme => theme.palette.gradients.primary,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  featureAnnouncement: {
    position: 'fixed',
    left: (theme: Theme) => theme.spacing(3),
    boxShadow: '3px 3px 10px 0 rgba(0, 0, 0, 0.25)',
    borderRadius: 4,
    zIndex: 'featureAnnouncement',
    overflow: 'hidden',
  },
  popoverPaper: {
    boxShadow: 3,
    border: 1,
    borderColor: 'grey100',
    borderRadius: 2,
  },
};
